import Vue from "vue";
import { Component } from "vue-property-decorator";
import { 
    IMessageNotificationListingModel, 
    MessageNotificationResquest,
    IMessageNotificationModel
} from "../../../../../../models/message-notification/index";
import { LabelSetting } from "../../../../../../i18n/locale-helper";
import { Getter, Mutation, namespace } from "vuex-class";
import { storeModules } from "../../../../../../store/index";
import { IUserListingModel } from "../../../../../../models/user/index";
import { IMessageNotificationParameterModel } from "../../../../../../models/message-notification/message-notification-parameter.model";
import { DateHelper } from "../../../../../../utils/date-helper";
import { DataHelper } from "../../../../../../utils/data-helper";
import { IMessageNotificationServices, MessageNotificationServices } from "../../../../../../services/message-notifications.service";
import { uniqBy } from 'lodash';
import { AuthVerified } from "../../../../../../models/generic/auth-transfer";
import { COMMON_MESSAGE_NOTIFICATION } from "../../../../../../store/types";
import { IAuthConfigModel } from "../../../../../../models/user/auth-config.model";
import EventBus from "../../../../../../utils/event-bus";
import { EVENT_BUS, NO_IMAGE } from "../../../../../../common/constants";
import { convertHREF, getBaseIconResourceUrl} from '../../../../../../utils/util';

const UserGetter = namespace(storeModules.User, Getter);
const CommonGetter = namespace(storeModules.Common, Getter);
const CommonMutation = namespace(storeModules.Common, Mutation);

@Component({
    components: {}
})
export default class NotificationHubComponent extends Vue {

    recordsUnread: number = 0;
    records: IMessageNotificationListingModel[];
    dtFilterType: string;
    pagination: {
        pageindex: number;
        pagesize: number;
        pagecount: number;
        totalpage: number;
        total: number;
    };
    dtDateRange: any;
    messageNotificationService: IMessageNotificationServices;
    loading: boolean;
    checkAllMessage = false;
    isIndeterminate = false;
    messageSelected: number[];
    notificationTypeCheckBoxComponentKey: number = 0;
    previewVisible = false;
    previewMessageId = 0;
    previewDetail: IMessageNotificationModel = null;
    isLoadingDetail: boolean = false;

    @UserGetter listOfUsers: IUserListingModel[];
    @UserGetter authConfig: IAuthConfigModel;

    @CommonGetter userSession: AuthVerified;

    @CommonGetter getFilterMessageNotification: IMessageNotificationParameterModel;
    @CommonMutation(COMMON_MESSAGE_NOTIFICATION.SET_FILTER) storeFilterParamater: (payload: IMessageNotificationParameterModel) => void;
    @CommonMutation(COMMON_MESSAGE_NOTIFICATION.SET_MARK_READ) storeMarkReadParamater: (payload: number[]) => void;
    @CommonMutation(COMMON_MESSAGE_NOTIFICATION.CLEAR_ALL_MARK_READ) clearAllMarkReadParamater: () => void;
    @CommonMutation(COMMON_MESSAGE_NOTIFICATION.REMOVE_MARK_READ) removeMarkReadParamater: (payload: number[]) => void;

    get parameter() {
        return this.getFilterMessageNotification;
    }

    get coPagination() {
        return this.pagination;
    }

    get lblSetting() {
        return LabelSetting;
    }

    get lblGlobal() {
        return LabelSetting.Global;
    }

    get coListOfUsers() {
        return this.listOfUsers;
    }

    get coListOfNotificationsGroup(): any[] {
        let groups = uniqBy(this.records, (c) => (new Date(c.Date) as any).toLongDate());
        return groups || [];
    }

    get coListOfResources(): number[] {
        const ids = this.parameter.UserIds;
        if (this.userSession && this.userSession.UserInfo && this.userSession.UserInfo.Id) {
            return ids.length === 0 ? [this.userSession.UserInfo.Id] : ids;
        }
        return [];
    }

    set coListOfResources(value: number[]) {
        this.storeFilterParamater({ UserIds: value });
        this.fetchData();
    }

    get coParameterSearch() {
        return this.parameter.Search;
    }

    set coParameterSearch(value) {
        value = value === "" ? null : value;
        this.storeFilterParamater({ Search: value });
    }

    handleSearch() {
        this.pagination.pageindex = 1;
        this.resetSelectedList();
        this.fetchData();
    }

    getListOfNotifications(group: any) {
        let items = this.records.filter(c => (new Date(c.Date) as any).toLongDate() == (new Date(group) as any).toLongDate())
        return items || [];
    }

    getDate(date: string) {
        if (!date) return "";

        const d = new Date(date);
        const lang = localStorage.getItem("lang") as any;

        const formatedDate = Intl.DateTimeFormat(lang, {
            weekday: "long",
            month: "short",
            day: "numeric",
            year: "numeric"
        }).format(d);
        return formatedDate;
    }

    getTime(date: string) {
        if (!date) return "";
        const lang = localStorage.getItem("lang") as any;
        return new Date(date).toLocaleTimeString(lang);
    }

    getIconUrl(path: string) {
        // if (this.authConfig && this.authConfig.ShareResourceUrl) {
        //     return this.authConfig.ShareResourceUrl + path;
        // }
        // return path;
        path = path || "";
        return getBaseIconResourceUrl() + path.replace('/icons', '');
    }

    constructor() {
        super();
        this.loading = false;
        this.records = [];
        this.messageSelected = [];
        this.dtFilterType = 'all';
        this.pagination = {
            pageindex: 1,
            pagesize: 20,
            pagecount: 5,
            totalpage: 0,
            total: 0
        };;
        this.dtDateRange = null;
        this.messageNotificationService = new MessageNotificationServices();
    }

    mounted() {

        console.log('notification-hub mounted');

        if (this.parameter.UserIds.length == 0) {
            this.storeFilterParamater({ UserIds: [this.userSession.UserInfo.Id] });
        }

        this.messageSelected = [];

        this.fetchData();

        EventBus.$on(EVENT_BUS.NOTIFICATION.NOTIFICATION_HUB_FETCH_DATA, () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        EventBus.$off(EVENT_BUS.NOTIFICATION.NOTIFICATION_HUB_FETCH_DATA);
    }

    changeFilter(f) {
        if (f == this.dtFilterType) {
            return;
        }

        this.dtFilterType = f;

        var now = DateHelper.addDays(new Date(), 1);
        if (f == "custom") {
            this.dtDateRange = null;
        } else {
            if (f == "all") {
                this.dtDateRange = null;
            } else if (f == "week") {
                var sinceDate = DateHelper.getDayAgo(now, 7);
                this.dtDateRange = [sinceDate, now];
            } else if (f == "month") {
                var sinceDate = DateHelper.getDayAgo(now, 30);
                this.dtDateRange = [sinceDate, now];
            }

            this.pagination.pageindex = 1;
            this.resetSelectedList();
            this.fetchData();
        }
    }

    changePage(page) {
        this.pagination.pageindex = page;
        this.resetSelectedList();
        this.fetchData();
    }

    changeCustom() {
        this.pagination.pageindex = 1;
        this.resetSelectedList();
        this.fetchData();
    }

    changeUserIds() {

    }

    resetSelectedList () {
        this.checkAllMessage = false;
        this.handleCheckAllMessage(false);
    }

    fetchData() {
        const request = new MessageNotificationResquest();
        if (this.dtDateRange) {
            this.storeFilterParamater({ FromDate: DataHelper.formatDateFromDate(this.dtDateRange[0]), ToDate: DataHelper.formatDateFromDate(this.dtDateRange[1]) });
        } else {
            this.storeFilterParamater({ FromDate: null, ToDate: null });
        }
        const oldParamSearch = this.parameter.Search;
        console.log('PARAM_STRING', oldParamSearch);
        
        request.Condition = this.parameter;
        request.PageIndex = this.pagination.pageindex;
        request.PageSize = this.pagination.pagesize;
        this.messageNotificationService.search(request)
            .then((response: any) => {
                console.log('fetchDATA', response);
                console.log(oldParamSearch, 'PARAM_STRING', this.parameter.Search);
                
                if (oldParamSearch === this.parameter.Search) { // async works sometimes incorrectly
                    const { listOfItems, pagination, TotalUnread } = response;
                    if (pagination) {
                        this.pagination.total = pagination.total;
                        this.pagination.pagecount = pagination.pagecount;
                    }
                    console.log(this.pagination);
                    if (listOfItems && Array.isArray(listOfItems)) {
                        this.records = listOfItems;
                    }
                    this.$emit('update:totalUnread', TotalUnread ? TotalUnread : 0);
                    this.recordsUnread = TotalUnread ? TotalUnread : 0;
                    this.messageSelected = [];
                }
            }).catch(err => console.log(err));
    }

    handleMarkRead(type: string, previewId?:number) {
        if (type == 'all') {
            this.storeFilterParamater({ Ids: null });
            const request = new MessageNotificationResquest();
            request.Condition = this.parameter;
            request.PageIndex = 1;
            request.PageSize = 1000000;  
            this.messageNotificationService.getUnreadIds(request)
                .then((response: any) => {
                    this.processMarkRead(response);
                }).catch(err => console.log(err));
        } else if (type == 'selected') {
            let selectedIds = previewId ? [previewId] :this.messageSelected;
            this.processMarkRead(selectedIds);
        }
    }

    processMarkRead(selectedIds:number[]) {
        this.storeMarkReadParamater(selectedIds);
        this.storeFilterParamater({ Ids: selectedIds });
        const request = new MessageNotificationResquest();
        request.Condition = this.parameter;
        request.PageIndex = this.pagination.pageindex;
        request.PageSize = this.pagination.pagesize;
        this.messageNotificationService.read(request)
            .then((response: any) => {
                this.messageSelected = [];
                this.isIndeterminate = null;
                this.fetchData();
                setTimeout(() => {
                    this.removeMarkReadParamater(selectedIds);
                }, 30000);
            }).catch(err => {
                this.removeMarkReadParamater(selectedIds);
                console.log(err);                
            });        
    }

    handleCheckAllMessage(val) {
        const ids = this.records.map(item => item.Id);
        this.messageSelected = val ? [...ids] : [];
        this.isIndeterminate = false;
        this.notificationTypeCheckBoxComponentKey += 1;
    }

    handleStopEvent() {

    }

    handleCheckMessageNotification(id: number) {
        const exist = this.messageSelected.find(item => item == id);
        if (exist) {
            for (let i = 0; i < this.messageSelected.length; i++) {
                if (this.messageSelected[i] == id) {
                    this.messageSelected.splice(i, 1);
                    break;
                }
            }
        } else {
            this.messageSelected.push(id);
        }
        let checkedCount = this.messageSelected.length;
        this.checkAllMessage = checkedCount === this.records.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.records.length;
    }

    getMessageChecked(id: number) {
        const exist = this.messageSelected.find(item => item == id);
        if (exist) {
            return true;
        }
        return false;
    }

    handlePreviewMessage(id: number) {
        if (this.previewMessageId === id) {
            this.previewVisible = false;
            this.previewMessageId = 0;
            return;
        }
        this.previewMessageId = id;
        this.previewVisible = true;
        this.handleMarkRead('selected', id);
        this.getNotificationDetail();
    }

    getConvertHREF(value: string) { return convertHREF(value); }

    async getNotificationDetail () {
        this.isLoadingDetail = true;
        this.messageNotificationService.detail(this.previewMessageId)
        .then(response => {
            this.previewDetail = response;
            this.isLoadingDetail = false;
        })
        .catch(err => {
            this.$message.error(err);
            this.isLoadingDetail = false;
            this.previewDetail = null;
        })
    }

    getNoIconUrl (event) {
        event.target.src = NO_IMAGE;
    }
}